export const SET_PLACE_POSITION = "SET_PLACE_POSITION";

export const setPlacePosition = (data) => {
  return {
    type: SET_PLACE_POSITION,
    payload: data,
  };
};


